import React from 'react';
import Combokeys from 'combokeys';

declare global {
    interface Window {
        shortcutManager: any;
    }
}

const shortcutManager = new Combokeys(window.top?.document);

// required so legacy firebird can trigger shortcuts when it is focused
if (window.top) {
    window.top.shortcutManager = shortcutManager;
}

interface Props {
    handlers: {};
}

export default class GlobalKeyboardShortcuts extends React.Component<Props> {
    static defaultProps = {
        handlers: {},
    };

    componentDidMount() {
        Object.entries(this.props.handlers).forEach(([shortcut, handler]) => {
            if (typeof handler === 'function') {
                shortcutManager.bind(shortcut, handler);
            }
        });
    }

    componentWillUnmount() {
        Object.keys(this.props.handlers).forEach(shortcut => shortcutManager.unbind(shortcut));
    }

    render() {
        return this.props.children;
    }
}
